import React, { useEffect, useState } from 'react'
import { request } from 'meinian-package/src/utils'
import Select from 'meinian-package/src/baseComponent/select'

const STATUS_OPTIONS = [
  { label: '一审', value: 1 },
  { label: '二审', value: 2 },
  { label: '三审', value: 3 },
  { label: '四审', value: 4 },
  { label: '五审', value: 5 },
  { label: '六审', value: 6 },
  { label: '七审', value: 7 },
  { label: '八审', value: 8 },
]
export default function StatusSelect({ value, onChange }) {
  const [option, setOption] = useState([])
  useEffect(() => {
    fetchData()
  }, [])
  const fetchData = async () => {
    const result = await request.post('/zhikuan/image-bus/inspiration/mark-levels')
    setOption(STATUS_OPTIONS.slice(0, result))
  }
  return <Select
    trigger="click"
    placeholder="当前状态"
    data={option}
    value={value}
    ulStyle={{ minWidth: '144px' }}
    container={document.body}
    onChange={(val, itemVal) => onChange(itemVal)}
  />
}
